import React from 'react'
import { Drawer } from '@mui/material';

// Componente para exibir o Drawer de exibicao. Para mobile
const DrawerExibicao = ({ fecharDrawer, corpo, anchor = 'bottom' })=>{

    return (
        <Drawer anchor={anchor} open={Boolean(corpo)} onClose={fecharDrawer}>
            {corpo}
        </Drawer>        
    )
}

export default DrawerExibicao;